import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

export const useDebounce = (value: any, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay]
  );

  return debouncedValue;
}

export const useDebounceSelector = (selector: any, delay = 300) => {
  // Use useSelector to get the *instant* value from the store
  const value = useSelector(selector);
  // State to hold the debounced value
  const [debouncedValue, setDebouncedValue] = useState<any>([value]);

  useEffect(() => {
    // Set a timeout to update the debounced value
    const handler = setTimeout(() => {
      setDebouncedValue([value]);
    }, delay);

    // Cleanup function to clear the timeout if the value changes again
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]); // Reruns when the instant Redux value changes

  return debouncedValue;
}